import { render, staticRenderFns } from "./SwitchTabPopup.vue?vue&type=template&id=cf119ec6&scoped=true&"
import script from "./SwitchTabPopup.vue?vue&type=script&lang=js&"
export * from "./SwitchTabPopup.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTabPopup.vue?vue&type=style&index=0&id=cf119ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf119ec6",
  null
  
)

export default component.exports